module.exports = __webpack_public_path__ + "ak.no2.64364506.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ak.no2.jpg
// module id = mMv7
// module chunks = 0